module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "detail"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav'), _vm._v(" "), (_vm.poData) ? [(_vm.poData.tags && _vm.poData.tags.length) ? _c('div', {
    staticClass: "topic"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'topic',
        params: {
          tag_id: _vm.poData.tags[0].tag_id
        }
      }
    }
  }, [_vm._v("\n        #" + _vm._s(_vm.poData.tags[0].tag_name) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("话题讨论 " + _vm._s(_vm.poData.tags[0].thread_count))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "po_main"
  }, [_c('div', {
    staticClass: "po_top"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('div', {
    staticClass: "avatar",
    style: ('background-image:url(' + _vm.poData.face + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: 'user_name sex_' + _vm.poData.gender
  }, [_vm._v(_vm._s(_vm.poData.username))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(_vm.poData.dateline)))])])]), _vm._v(" "), (_vm.poData.tags && _vm.poData.tags.length) ? _c('div', {
    staticClass: "stamp",
    style: ('background-image:url(' + _vm.poData.tags[0].tag_stick + ')')
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "po_content"
  }, [_c('p', {
    staticClass: "po_txt",
    domProps: {
      "innerHTML": _vm._s(_vm.poData.content)
    }
  }), _vm._v(" "), (_vm.poData.extra.titlte) ? _c('a', {
    staticClass: "po_tag",
    attrs: {
      "href": _vm.poData.extra.url
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("\n            " + _vm._s(_vm.poData.extra.titlte) + "\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.poData.images) ? _c('PicBox', {
    attrs: {
      "images": _vm.poData.images,
      "type": _vm.poData.type
    }
  }) : _vm._e(), _vm._v(" "), (_vm.poData.address) ? _c('div', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.poData.address))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "po_ctrl"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.openApp
    }
  }, [_c('div', {
    staticClass: "icon comment_btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("评论")])]), _vm._v(" "), (_vm.poData.is_praise) ? _c('div', {
    staticClass: "item on",
    on: {
      "click": _vm.onZan
    }
  }, [_c('div', {
    staticClass: "icon zan_btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("已赞")])]) : _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.onZan
    }
  }, [_c('div', {
    staticClass: "icon zan_btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("点赞")])])]), _vm._v(" "), (_vm.poData.praise && _vm.poData.praise.length) ? _c('div', {
    staticClass: "zan_wrap"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("他们点了赞(" + _vm._s(_vm.poData.praise.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "avatar_list"
  }, [_vm._l((_vm.poData.praise), function(item, index) {
    return (index < 7) ? _c('div', {
      key: index,
      staticClass: "avatar",
      style: ('background-image:url(' + item.face + ')')
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "zan_count"
  }, [_vm._v(_vm._s(_vm.poData.praise.length) + "赞")]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, [_c('div', {
    staticClass: "circle-tit"
  }, [_c('i', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("评论" + _vm._s(_vm.poData.comment_count == 0 ? '' : ' (' + _vm.poData.comment_count + ')'))])]), _vm._v(" "), (_vm.poData.comments) ? [_c('div', {
    staticClass: "comment-list"
  }, _vm._l((_vm.poData.comments), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "comment-item"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "user_info"
    }, [_c('div', {
      staticClass: "avatar",
      style: ('background-image:url(' + item.cuinfo.face + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', {
      staticClass: "user_name"
    }, [_c('span', {
      class: 'nick sex_' + item.cuinfo.gender
    }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.username) ? [_c('span', {
      staticClass: "to"
    }, [_vm._v("回复")]), _vm._v(" "), _c('span', {
      class: 'nick sex_' + item.ruinfo.gender
    }, [_vm._v(_vm._s(item.ruinfo.username))])] : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(item.dateline)))])])]), _vm._v(" "), _c('p', {
      staticClass: "comment-txt",
      domProps: {
        "innerHTML": _vm._s(item.comment)
      }
    })])
  }), 0), _vm._v(" "), (_vm.poData.comment_count - _vm.poData.comments.length > 0) ? _c('a', {
    staticClass: "big-btn",
    on: {
      "click": _vm.loadComment
    }
  }, [_vm._v("\n          更多精彩评论（" + _vm._s(_vm.poData.comment_count - _vm.poData.comments.length) + "条）\n        ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.poData.comment_count == 0) ? _c('div', {
    staticClass: "no_comment"
  }, [_c('p', [_vm._v("暂无评论")]), _vm._v(" "), _c('p', [_vm._v("快快抢沙发")])]) : _vm._e()], 2), _vm._v(" "), (_vm.poData.recommend) ? _c('div', {
    staticClass: "others"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "pic",
    attrs: {
      "src": _vm.poData.recommend.tag_img
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("#" + _vm._s(_vm.poData.recommend.tag_name) + "#")]), _vm._v(" "), _c('p', {
    staticClass: "count"
  }, [_vm._v("已有" + _vm._s(_vm.poData.recommend.thread_count) + "份作品")]), _vm._v(" "), _c('a', {
    staticClass: "big-btn",
    on: {
      "click": function($event) {
        return _vm.openAppPoTopic(_vm.poData.recommend.tag_id)
      }
    }
  }, [_vm._v("我要参与")])]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle-tit"
  }, [_c('i', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("大家都在Po")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-64d1555f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/detail/Detail.vue
// module id = 121
// module chunks = 1